import productListJSON from '@/config/productData.json';
import EventBus from '@/EventBus';
import Text from '@/components/DesignObjects/TextObject';
import Image from '@/components/DesignObjects/ImageObject';
import Background from '@/components/DesignObjects/BackgroundObject';

export default {
  namespaced: true,
  state:      {
    count: 0,
  },
  mutations: {
    increase(state, payload) {
      state.count += payload.amount;
    },
  },
  actions: {
    loadProductFromAPI(context) {
      // TODO : modify URL newBMC to BMCv2 ?
      // const url = new URL('https://dev2.wysiwyg.bankmarketingcenter.com/newBMC/web_service.aspx?');
      // url.searchParams.set('method', 'GetProductInfo');
      // url.searchParams.set('domainURL', 'https://www.bankmarketingcenter.com/');
      // url.searchParams.set('userId', '21d29854-fb88-45e6-9a12-b1f4e6c67d45');
      // url.searchParams.set('bankId', 'fde5ed9d-816f-43fd-89f3-97a542947193');
      // url.searchParams.set('productId', productListJSON.products[context.state.selectedProductIndex].productId);
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : null;
      // const userId = '21d29854-fb88-45e6-9a12-b1f4e6c67d45';
      const bankId = 'fde5ed9d-816f-43fd-89f3-97a542947193';
      const url    = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetProductInfo&domainURL=https://www.${this.$store.getters.getBMCInstance}.com/&bankId=${bankId}&userId=${userId}&productId=${productListJSON.products[context.state.selectedProductIndex].productId}`;

      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', (data) => {
        context.dispatch('loadProductColor', data).then();
      });
      oReq.addEventListener('error', (e) => {
        EventBus.$emit('showHideLoader', false);
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    loadProductColor(context, data) {
      // TODO : modify URL newBMC to BMCv2 ?
      // const url = new URL('https://dev2.wysiwyg.bankmarketingcenter.com/newBMC/web_service.aspx?');
      // url.searchParams.set('method', 'GetPmsColorNewInfo');
      // url.searchParams.set('domainURL', 'https://www.bankmarketingcenter.com/');
      // url.searchParams.set('bankId', 'fde5ed9d-816f-43fd-89f3-97a542947193');
      // url.searchParams.set('productId', productListJSON.products[context.state.selectedProductIndex].productId);

      const bankId = 'fde5ed9d-816f-43fd-89f3-97a542947193';
      const url    = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetProductInfo&domainURL=https://www.${this.$store.getters.getBMCInstance}.com/&bankId=${bankId}&productId=${productListJSON.products[context.state.selectedProductIndex].productId}`;


      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', (colorResponse) => {
        context.commit('updateCMYKColor', colorResponse.target.response);
        context.dispatch('parseProductFromXML', data.target.response).then();
        EventBus.$emit('showHideLoader', false);
      });
      oReq.addEventListener('error', (e) => {
        EventBus.$emit('showHideLoader', false);
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    parseProductFromXML(context, xmlObject) {
      const xmlParser    = new DOMParser();
      const convertedDoM = xmlParser.parseFromString(xmlObject, 'text/xml');
      const productXML   = (convertedDoM.getElementsByTagName('GetProductInfoResult').length) ? convertedDoM.getElementsByTagName('GetProductInfoResult')[0] : convertedDoM.getElementsByTagName('GetProductInfoForOrderResult')[0];
      const pageWidth    = productXML.getElementsByTagName('PageWidths')[0];
      const pageHeight   = productXML.getElementsByTagName('PageHeights')[0];
      context.dispatch('convertProductXMLToJsonForRootLevel', productXML).then(() => {
        const pageData = {
          width:  pageWidth,
          height: pageHeight,
        };
        context.dispatch('makeProductPagesFromXML', pageData).then(() => {
          context.dispatch('extractTextObjectListFromProductXml', productXML.getElementsByTagName('TextField')).then();

          context.dispatch('extractImageObjectListFromProductXml', productXML.getElementsByTagName('ImageField')).then();

          context.dispatch('extractBackgroundFieldObjectListFromProductXml', productXML.getElementsByTagName('BackgroundField')).then();

          context.dispatch('extractOtherProductValuesFromProductXml', productXML).then();
        });
      });
    },
    extractTextObjectListFromProductXml(context, textFields) {
      for (let textFieldIndex = 0; textFieldIndex < textFields.length; textFieldIndex++) {
        let textObject                                                                              = new Text();
        textObject                                                                                  = textObject.initFromXML(textFields[textFieldIndex]);
        const listPageIndex                                                                         = textObject.data.PageNo - 1;
        let listObjectIndex                                                                         = context.state.selectedProduct.pages[listPageIndex].objectList.push(textObject.data);
        listObjectIndex                                                                            -= 1;
        context.state.selectedProduct.pages[listPageIndex].objectList[listObjectIndex].elementIndex = listObjectIndex;
        context.state.selectedProduct.pages[listPageIndex].objectList[listObjectIndex].PageNo       = listPageIndex;
      }
    },
    extractImageObjectListFromProductXml(context, imageFields) {
      for (let imageFieldIndex = 0; imageFieldIndex < imageFields.length; imageFieldIndex++) {
        let imageField                                                                               = new Image();
        imageField                                                                                   = imageField.initFromXML(imageFields[imageFieldIndex]);
        const listPageIndex                                                                          = imageField.data.PageNo - 1;
        let listObjectIndex                                                                          = context.state.selectedProduct.pages[listPageIndex].objectList.push(imageField.data);
        listObjectIndex                                                                             -= 1;
        context.state.selectedProduct.pages[listPageIndex].objectList[listObjectIndex].elementIndex  = listObjectIndex;
        context.state.selectedProduct.pages[listPageIndex].objectList[listObjectIndex].listPageIndex = listPageIndex;
      }
    },
    extractBackgroundFieldObjectListFromProductXml(context, backgroundFields) {
      for (let backgroundFieldIndex = 0; backgroundFieldIndex < backgroundFields.length; backgroundFieldIndex++) {
        let backgroundField                                                                         = new Background();
        backgroundField                                                                             = backgroundField.initFromXML(backgroundFields[backgroundFieldIndex]);
        const listPageIndex                                                                         = backgroundField.data.PageNo - 1;
        let listObjectIndex                                                                         = context.state.selectedProduct.pages[listPageIndex].objectList.push(backgroundField.data);
        listObjectIndex                                                                            -= 1;
        context.state.selectedProduct.pages[listPageIndex].objectList[listObjectIndex].elementIndex = listObjectIndex;
        context.state.selectedProduct.pages[listPageIndex].objectList[listObjectIndex].PageNo       = listPageIndex;
      }
    },
    extractOtherProductValuesFromProductXml(context, productXML) {
      // Adding property in product that are receive empty
      const YCrop                         = productXML.getElementsByTagName('YCrop');
      context.state.selectedProduct.YCrop = YCrop.innerHTML ? YCrop.innerHTML : 0;

      const XCrop                         = productXML.getElementsByTagName('XCrop');
      context.state.selectedProduct.XCrop = XCrop.innerHTML ? XCrop.innerHTML : 0;

      const PageHeights                                = productXML.getElementsByTagName('PageHeights');
      let temp                                         = PageHeights[0].textContent ? Number(PageHeights[0].textContent) : 0;
      context.state.selectedProduct.PageHeights        = {};
      context.state.selectedProduct.PageHeights.double = temp;

      const PageWidths                                = productXML.getElementsByTagName('PageWidths');
      temp                                            = PageWidths[0].textContent ? Number(PageWidths[0].textContent) : 0;
      context.state.selectedProduct.PageWidths        = {};
      context.state.selectedProduct.PageWidths.double = temp;

      const WidthCrop                         = productXML.getElementsByTagName('WidthCrop');
      context.state.selectedProduct.WidthCrop = WidthCrop.innerHTML ? Number(WidthCrop.innerHTML) : context.state.selectedProduct.PageWidths.double;

      const HeightCrop                         = productXML.getElementsByTagName('HeightCrop');
      context.state.selectedProduct.HeightCrop = HeightCrop.innerHTML ? Number(WidthCrop.innerHTML) : context.state.selectedProduct.PageHeights.double;

      const CsvFilePath                         = productXML.getElementsByTagName('CsvFilePath');
      context.state.selectedProduct.CsvFilePath = CsvFilePath.innerHTML ? CsvFilePath.innerHTML : null;

      const TriviaQuestions                         = productXML.getElementsByTagName('TriviaQuestions');
      context.state.selectedProduct.TriviaQuestions = TriviaQuestions.innerHTML ? TriviaQuestions.innerHTML : null;
    },
    makeProductPagesFromXML(context, { width, height }) {
      const pageList = [];
      for (let pageIndex = 0; pageIndex < width.children.length; pageIndex++) {
        pageList.push({
          objectList: [],
          width:      parseFloat(width.children[pageIndex].innerHTML),
          height:     parseFloat(height.children[pageIndex].innerHTML),
        });
      }
      context.state.selectedProduct.pages = pageList;
    },
    convertProductXMLToJsonForRootLevel(context, XML) {
      const tempJson = {};
      for (let i = 0; i < XML.childElementCount; i++) {
        let val = XML.childNodes[i].innerHTML;
        if (XML.childNodes[i].innerHTML == 'true' || XML.childNodes[i].innerHTML === 'false') {
          val = XML.childNodes[i].innerHTML == 'true';
        }
        tempJson[XML.childNodes[i].tagName] = val;
      }
      context.state.selectedProduct = tempJson;
    },

  },
};
